import API from "./API";

import axios from "axios";
import { NextResponse } from "next/server";

// export const sendOtpApi = (params) => {
//   return API.post(`/otp/send?mobileNumber=${params?.mobileNumber}`)
//     .then((response) => {
//       return response;
//     })
//     .catch((error) => {
//       throw error;
//     });
// };

// export const verifyOtpApi = params => {
//   return API.post(
//     `otp/verify`, { params }
//   )
//     .then(response => {
//       return response;
//     })
//     .catch(error => {
//       throw error;
//     });
// };

export const verifyOtpWidjetApi = async () => {
  const response = await fetch("/api/verify-access-token", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
  });

  const data = await response.json();
  return data;
};

export async function sendOtpApi(payload) {
  const { mobileNumber } = payload;

  const response = await fetch("/api/otp-sent", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ mobile: mobileNumber }),
  });

  const data = await response.json();
  return data;
}

export async function verifyOtpApi(payload) {
  const { mobileNumber, otp } = payload;

  const response = await fetch("/api/otp-verify", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      mobile: mobileNumber,
      otp: otp,
    }),
  });

  const data = await response.json();
  console.log('verifyOtpApi ', data);
  return data;
}

export const resentOtpApi = async (payload) => {
  const { mobileNumber } = payload;

  const response = await fetch("/api/otp-sent", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({ mobile: mobileNumber }),
  });

  const data = await response.json(); // ✅ parse JSON
  return data; // ✅ plain object
};

export const socialSignUpApi = async (payload) => {
  try {
    const response = await API.post(`/auth/social/signup`, payload);
    return response;
  } catch (error) {
    throw error;
  }
};